import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/settings/rule-engine/')({
  validateSearch: zodValidator(withDefaults(schema.RULE_ENGINE, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const path = PAGE_PATHS.RULE_ENGINE;
    const app = APP_PATHS.IDENTITIES;
    const {
      validatePermissions,
      userPermissions: { hasAllowedPermission },
    } = context;
    const isAllowed = hasAllowedPermission({ app, path });
    validatePermissions({ isAllowed, preload });
  },
});
